import styled from 'styled-components';
import { border1 } from 'utils/style/colors';

interface IReportConfigContainerProps {
  compactView: boolean;
}
interface IReportConfigContainerProps {
  compactView: boolean;
}

export const ReportSection = styled.div<IReportConfigContainerProps>`
  display: flex;
  position: relative;
  flex-grow: 1;
  width: 100%;
  overflow: auto;
  margin: ${({ compactView }) => (compactView ? '0rem' : '1rem')};
`;

export const ReportHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ReportBody = styled.div`
  margin-top: 2em;
`;

export const Message = styled('p')`
  font-size: 1em;
  text-align: center;
  margin: 1em 0;
`;

export const ReportRangeDate = styled('span')`
  color: gray;
  text-align: center;
  margin-bottom: 0.45rem;
`;

export const ReportConfigContainer = styled('div')<IReportConfigContainerProps>`
  border: ${border1};
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  //width: 22rem;
  height: 100%;
  margin: 0 1em;
  display: flex;
  //align-items: ${({ compactView }) => compactView && 'center'};
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  @media screen and (max-width: 1000px) {
    align-items: center;
    flex-direction: column !important;
  }
`;
